import React from "react";
import { Col, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import "./HazardInfoModal.css"
import ConstantData from "../../Utils/Constant";

const HazardInfoModal = ({show,info,closePopup}) => {
  return (
    
      <Modal 
 isOpen={show} toggle={closePopup} className="mapOverlayes">
        <ModalHeader toggle={closePopup} style={{ paddingBottom: "5px", borderBottom: 'none' }}>
          {info.name}
        </ModalHeader>
        <ModalBody
          className="pb-2 pt-1"
          style={{
            maxHeight: "calc(100vh - 130px)",
            overflowY: "auto",
          }}
        >
          <div>
            {info.id === ConstantData.advancedMapOverlaysIds.fema ? (
              <div style={{fontSize: '13px'}}>
                <p style={{marginBottom: '5px'}}>
                  <strong>Rating : </strong> FEMA assigns qualitative ratings
                  into five categories based on how similar or different they
                  are from others:
                </p>
                <Row className="fema-ul">
                  <Col md={4} className="row_one">
                  <ul>
                  <li>Very High</li>                  
                  <li>Relatively High</li>                  
                  </ul>
                  </Col>
                  <Col md={4} className="row_two p-0">
                  <ul>
                  <li>Relatively Moderate</li>
                  <li>Relatively Low</li>
                  </ul>
                  </Col>
                  <Col md={4} className="row_three">
                  <ul><li>Very Low</li></ul>
                  </Col>
                </Row>
                
              </div>
            ) : (
              ""
            )}
            <table className="table-state-siz">
              <thead></thead>
              <tbody>
                <tr>
                  <td>Name</td>
                  <td style={{fontWeight: '500'}}>
                    {info.layertype === "line"
                      ? "Source"
                      : "Description"}
                  </td>
                </tr>
                {info.descriptions.map((info, index) => {
                  return (
                    <tr key={index}>
                      <td>{info.name}</td>
                      <td style={{color:!info.description ? "red" :""}}>{info.description || "No traffic data available"}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </ModalBody>
      </Modal>
  );
};

export default HazardInfoModal;
